// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__25POh","productName":"Table_productName__10Aqr"};